export enum PhoneLineType {
  FixedVoIP = 'FixedVoIP',
  NonFixedVoIP = 'NonFixedVoIP',
  Landline = 'Landline',
  Mobile = 'Mobile',
  Other = 'Other',
}

export enum UnderwritingResult {
  Success = 'Success',
  Skip = 'Skip',
  FrozenReport = 'Frozen Report',
  Decline = 'Decline',
  AddCoBorrower = 'Add CoBorrower',
  CoBorrowerHasActiveApplication = 'CoBorrower Has Active Application',
  CoBorrowerLocked = 'CoBorrower Locked',
}

export enum PrequalificationNextStep {
  Dashboard = 'Dashboard',
  PosOffers = 'PosOffers',
  HilOffers = 'HilOffers',
  PropertyInformation = 'PropertyInformation',
  LoanInformation = 'LoanInformation',
  AdditionalCoBorrowerInfo = 'AdditionalCoBorrowerInfo',
  CreateAccount = 'CreateAccount',
  Decline = 'Decline',
  NoApplicationInProgress = 'NoApplicationInProgress',
  FirstAfterSignInStep = 'FirstAfterSignInStep',
}
